import { render } from "./PopularStreamsCarousel.vue?vue&type=template&id=714f9678&scoped=true"
import script from "./PopularStreamsCarousel.vue?vue&type=script&lang=js"
export * from "./PopularStreamsCarousel.vue?vue&type=script&lang=js"

import "./PopularStreamsCarousel.vue?vue&type=style&index=0&id=714f9678&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714f9678"]])

export default __exports__